import { Dialog } from "@qn/ui";
import { useEffect, useState } from "react";
import { useFocus } from "../lib/focus";
import { useT } from "../lib/i18n";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);

/** "?" (outside text fields) or Ctrl/Cmd+/ opens the list of keyboard shortcuts. */
export function ShortcutsDialog() {
  const t = useT();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const k = (e: KeyboardEvent) => {
      if (e.key === "." && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        useFocus.getState().toggle();
        return;
      }
      if (e.key === "Escape" && useFocus.getState().on) useFocus.getState().off();
      const el = e.target as HTMLElement | null;
      const typing =
        el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
      if (
        (e.key === "/" && (e.ctrlKey || e.metaKey)) ||
        (e.key === "?" && !typing && !e.ctrlKey && !e.metaKey)
      ) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    addEventListener("keydown", k);
    return () => removeEventListener("keydown", k);
  }, []);
  const mod = isMac ? "⌘" : "Ctrl";
  const rows: Array<[string, string]> = [
    [`${mod} + K`, t("shortcuts.search")],
    ["Enter", t("shortcuts.send")],
    ["Shift + Enter", t("shortcuts.newline")],
    [`${mod} + .`, t("shortcuts.focus")],
    ["/", t("shortcuts.slash")],
    ["Tab", t("shortcuts.accept")],
    ["Esc", t("shortcuts.close")],
    ["?", t("shortcuts.help")],
  ];
  return (
    <Dialog open={open} onOpenChange={setOpen} title={t("shortcuts.title")}>
      <ul className="divide-y divide-[var(--line)] text-sm">
        {rows.map(([k, d]) => (
          <li key={k} className="flex items-center justify-between gap-4 py-2">
            <span>{d}</span>
            <kbd
              dir="ltr"
              className="rounded-md border border-[var(--line)] bg-[var(--surface-3)] px-2 py-0.5 font-mono text-xs"
            >
              {k}
            </kbd>
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
